import React from "react";
import "swiper/css/bundle";
import AllRoutes from "./AllRoutes/AllRoutes";
import { AnimatePresence } from "framer-motion";

import { ThemeProvider } from "styled-components";

const theme = {
  background: "white",
  headerBgColor: "#e76364",
  headerFontSize: "20px",
  botBubbleColor: "#e76364",
  headerFontColor: "white",
  botFontColor: "white",
  userBubbleColor: "#FF5733",
  userFontColor: "white",
};

function App() {
  return (
    <>
      <AnimatePresence mode="wait">
        <AllRoutes>
          {/* Home Component route has been created..... */}
        </AllRoutes>
      </AnimatePresence>

      <ThemeProvider theme={theme}></ThemeProvider>
    </>
  );
}

export default App;
